/*
 index

 Główny plik strony  
 Renderowanie w miejscu wyznaconym rzez element root
 
 historia: 
  04-2019 JW - start
  04-05-2019 - rezygnacja z redux-react-hook
*/

import React from "react"
import ReactDOM from "react-dom"

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
/*
import * as serviceWorker from "./serviceWorker"
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
*/